import { Card, CardContent } from '@/ui/design-system/components';
import CategoryDescription from 'components/CategoryDescription';
import { useCategoryDescriptions } from 'utils/hooks';

function CategoryDescriptionCard({ categoryId, categoryName, flavors }) {
    const { data, isLoading, status } = useCategoryDescriptions({
        categories: categoryId ? [categoryId] : null,
    });
    const match = data?.find(({ category }) => category === categoryId);
    const hasDescription = !!match?.description;
    if (!isLoading && status !== 'idle' && !hasDescription) return null;
    return (
        <Card>
            <CardContent className="p-4">
                <CategoryDescription
                    categoryId={categoryId}
                    categoryName={categoryName}
                    flavors={flavors}
                    plain
                />
            </CardContent>
        </Card>
    );
}

export default CategoryDescriptionCard;
